import { render } from "./FileStructureCard.vue?vue&type=template&id=4eb7b600"
import script from "./FileStructureCard.vue?vue&type=script&lang=js"
export * from "./FileStructureCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__